import { SVGProps } from 'react';

export const TikTokLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1_2)">
      <path
        d="M16.6016 5.30007C15.9165 4.6018 15.4636 3.69177 15.3165 2.70007H12.5016V15.8001C12.4809 16.3983 12.2406 16.9687 11.8265 17.4001C11.4124 17.8315 10.8532 18.0901 10.2566 18.1301C9.04831 18.1301 8.00659 17.1401 8.00659 15.8701C8.00659 14.3701 9.44831 13.2801 10.9483 13.6701V10.8001C7.87331 10.5001 5.15659 12.8701 5.15659 15.8701C5.15659 18.7901 7.61659 21.0001 10.2266 21.0001C13.0766 21.0001 15.3766 18.7001 15.3766 15.8701V9.04007C16.4682 9.82775 17.7561 10.2697 19.0866 10.3101V7.49007C18.1597 7.47189 17.2643 7.16243 16.5266 6.60607L16.6016 5.30007Z"
        fill="black"
      />
      <path
        d="M16.5266 6.60607C17.2643 7.16243 18.1597 7.47189 19.0866 7.49007V7.00007C18.1597 6.98189 17.2643 6.67243 16.5266 6.11607V6.60607Z"
        fill="#00F2EA"
      />
      <path
        d="M15.3165 2.70007C15.4636 3.69177 15.9165 4.6018 16.6016 5.30007L16.5266 6.11607V6.60607L16.6016 5.30007C15.9165 4.6018 15.4636 3.69177 15.3165 2.70007Z"
        fill="#00F2EA"
      />
      <path
        d="M10.9483 13.6701C9.44831 13.2801 8.00659 14.3701 8.00659 15.8701C8.00659 17.1401 9.04831 18.1301 10.2566 18.1301C10.8532 18.0901 11.4124 17.8315 11.8265 17.4001C12.2406 16.9687 12.4809 16.3983 12.5016 15.8001V2.70007H15.3165C15.3165 2.70007 15.3165 2.77007 15.3165 2.80007H12.5016V15.9001C12.4809 16.4983 12.2406 17.0687 11.8265 17.5001C11.4124 17.9315 10.8532 18.1901 10.2566 18.2301C9.04831 18.2301 8.00659 17.2401 8.00659 15.9701C8.00659 14.3701 9.44831 13.2801 10.9483 13.6701Z"
        fill="#FF004F"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_2">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
); 